import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

export type ApplicationFilters = {
  tags: string[]
  applicationPhaseId: string
  status: 'active' | 'rejected'
  answers: Record<string, string>
}

const DEFAULT_FILTERS: ApplicationFilters = {
  tags: [],
  applicationPhaseId: '-1',
  status: 'active',
  answers: {},
}

export const useApplicationsFilters = (jobId: string) => {
  const { search, onSearch } = useDebouncedSearch()
  const [storedFilters, setFilters] = useLocalStorage<ApplicationFilters>(
    `${LOCAL_STORAGE_KEYS.atsApplicationsFilters}:${jobId}`,
    DEFAULT_FILTERS
  )
  const filters = storedFilters!

  const onFiltersChange = (newFilters: Partial<ApplicationFilters>) => {
    setFilters({ ...filters, ...newFilters })
  }

  return {
    search,
    onSearch,
    filters,
    onFiltersChange,
  }
}
